//Dependency
import {
    LOG_OUT, GET_USERS_SUCCESS, GET_CATEGORY_ITEM_SUCCESS, GET_ITEMS_SUCCESS,
    AUDIT_CATEGORY_LIST, GET_AUDIT_ITEM_LIST, ADD_AUDIT_ITEM, UPDATE_AUDIT_ITEM, 
    DELETE_AUDIT_ITEM, GET_AUDIT_STATUS, UPDATE_AUDIT_STATUS, GET_CURRENT_COMP_PROFILE
} from "./ActionTypes";
import ComplianceAuditService from "../services/ComplianceAuditService";
import {getUser} from "../utils/TokenManager";
import {axiosInstanceWithToken}  from "../utils/Client";

//Get user list action
const getUsersSuccess = userList => ({ type : GET_USERS_SUCCESS, userList});

//Get category and respective items action
const getCategoryAndItemsSuccess = categoryList => ({ type : GET_CATEGORY_ITEM_SUCCESS, categoryList});

const getItemsAllotedToUserSuccess = itemsList => ({ type : GET_ITEMS_SUCCESS, itemsList });

//Function to get user data 
export const getUsers = ( locationId ) => (
    async (dispatch) => {
        try {
            const userListData = await ComplianceAuditService.getUserList(locationId);

            if (getUser()['app-version'] !== userListData.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === userListData.status) {
                dispatch(getUsersSuccess(userListData.data.user));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

// get all category and dispatch to redux store
export const getAuditCategoryList = ( locationId ) => (
    async (dispatch) => {
        try {
            const result = await ComplianceAuditService.getAuditCategoryList(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                dispatch({
                    type: AUDIT_CATEGORY_LIST,
                    categoryMasterList: result.data
                });
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

// get audit items of a category and dispatch to redux store
export const getAuditItemList = (categoryId) => (
    async (dispatch) => {
        try {
            const result = await ComplianceAuditService.getAuditItemList(categoryId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                dispatch({
                    type: GET_AUDIT_ITEM_LIST,
                    itemList: result.data
                });
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

// update an audit item and list in store
export const AddAuditItem = (itemObj, categoryId) => (
    async (dispatch) => {
        try {
            const result = await ComplianceAuditService.AddAuditItem(itemObj, categoryId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (201 === result.status) {
                dispatch({
                    type: ADD_AUDIT_ITEM,
                    newItem: result.data
                });
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

// update an audit item and list in store
export const updateAuditItem = (itemObj) => (
    async (dispatch) => {
        try {
            const result = await ComplianceAuditService.updateAuditItem(itemObj);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                dispatch({
                    type: UPDATE_AUDIT_ITEM,
                    itemObj: result.data
                });
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

// delete an audit item and upadte audit item list in store
export const deleteAuditItem = (itemId) => (
    async (dispatch) => {
        try {
            const result = await ComplianceAuditService.deleteAuditItem(itemId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                dispatch({
                    type: DELETE_AUDIT_ITEM,
                    itemId
                });
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

//Function to get category there respective Items
export const getCategoryAndItems = ( locationId ) => (
    async (dispatch) => {
        try {
            const categoryData = await ComplianceAuditService.getCategoryAndItems(locationId);

            if (getUser()['app-version'] !== categoryData.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === categoryData.status) {
                dispatch(getCategoryAndItemsSuccess(categoryData.data));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

//Function to get category there respective Items
export const getItemsAllotedToUser = ( userId , KPI) => (
    async (dispatch) => {
        try {
            const itemsData = await ComplianceAuditService.getItemsAllotedToUser(userId, KPI);

            if (getUser()['app-version'] !== itemsData.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === itemsData.status) {
                dispatch(getItemsAllotedToUserSuccess(itemsData.data));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

//Function to send request to save items alloted to user
export const sendItemsAllotedToUser = (requestObject, compId, kpiId) => (
    async (dispatch) => {
        try {
            const itemsData = await ComplianceAuditService.sendItemsAllotedToUser(
                requestObject, compId,kpiId
            );

            if (getUser()['app-version'] !== itemsData.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (201 === itemsData.status || 200 === itemsData.status) {
                dispatch(getItemsAllotedToUserSuccess(itemsData.data));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getAuditResponse = (compId, kpiId,auditId='') => (
    async (dispatch) => {
        try {
            let result = await ComplianceAuditService.getAuditForm(compId,kpiId, auditId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const updateAuditResponse = (responseList, compId, auditKPI, auditId='') => (
    async (dispatch) => {
        try {
            let result = await ComplianceAuditService.updateAuditForm(
                compId, auditKPI,responseList, auditId
            );

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const fileuploadResponse = (responseList, compId, id) => (
    async (dispatch) => {
        try {
            let result = await ComplianceAuditService. fileuploadAuditForm (
                compId, responseList, id
            );

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const printAuditResponse = (compId, auditId='') => (
    async (dispatch) => {
        try {
            let result = await ComplianceAuditService.getAuditResponsePDF(compId, auditId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getArchivedAudits = (userId='') => (
    async (dispatch) => {
        try {
            userId = userId ? userId : getUser().id;
            let result = await ComplianceAuditService.getArchivedAudits(userId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const AuditAction = (action) => (
    async (dispatch) => {
        try {
            let result;
            switch (action.type) {
                case GET_AUDIT_STATUS: {
                    result = await axiosInstanceWithToken.get(
                        `/audit/status/${action.auditId}/`
                    );
                    break;
                }
                case UPDATE_AUDIT_STATUS: {
                    result = await axiosInstanceWithToken.put(
                        `/audit/status/${action.auditId}/`, action.auditObj
                    );
                    break;
                }
                case GET_CURRENT_COMP_PROFILE: {
                    result = await axiosInstanceWithToken.get(`/compensation/active/profile/`);
                    break;
                }

                default:
                    result = await axiosInstanceWithToken.get(
                        `/audit/status/${action.auditId}/`
                    );
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status || 201 === result.status) {
                dispatch({...action, response: result.data});
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/ComplianceAuditAction.js